var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"80%","margin":"0 auto"}},[_c('el-input',{attrs:{"type":"text"},model:{value:(_vm.inputCookie),callback:function ($$v) {_vm.inputCookie=$$v},expression:"inputCookie"}}),_c('el-button',{staticClass:"mt_20",on:{"click":_vm.sendCookie}},[_vm._v("发送")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }